import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialShare = ({ registrationId, profileType }) => {
  const [copied, setCopied] = useState(false);

  const shareText = `🎉 Just enrolled in Solvarsity ${profileType} program! Excited to start my journey towards a successful tech career. #Solvarsity #TechCareer #SkillDevelopment`;
  const shareUrl = `https://solvarsity.com/success?ref=${registrationId}`;

  const socialPlatforms = [
    {
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: 'text-blue-600',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&summary=${encodeURIComponent(shareText)}`
    },
    {
      name: 'Twitter',
      icon: 'Twitter',
      color: 'text-blue-400',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      color: 'text-blue-700',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`
    },
    {
      name: 'WhatsApp',
      icon: 'MessageCircle',
      color: 'text-green-600',
      url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`
    }
  ];

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const handleSocialShare = (platform) => {
    window.open(platform.url, '_blank', 'width=600,height=400');
  };

  return (
    <div className="bg-surface border border-border rounded-xl p-6 mb-8">
      <div className="flex items-center space-x-2 mb-6">
        <Icon name="Share2" size={20} color="var(--color-primary)" strokeWidth={2} />
        <h2 className="text-xl font-semibold text-foreground">
          Share Your Achievement
        </h2>
      </div>

      <div className="text-center mb-6">
        <p className="text-sm text-text-secondary mb-4">
          Celebrate your success and inspire others to join Solvarsity!
        </p>
        
        {/* Achievement Badge */}
        <div className="inline-flex items-center space-x-2 px-4 py-3 bg-gradient-to-r from-primary/10 to-success/10 border border-primary/20 rounded-lg mb-6">
          <Icon name="Award" size={20} color="var(--color-primary)" strokeWidth={2} />
          <span className="text-sm font-semibold text-foreground">
            Enrolled in {profileType} Program
          </span>
          <Icon name="Sparkles" size={16} color="var(--color-accent)" strokeWidth={2} />
        </div>
      </div>

      {/* Social Media Buttons */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {socialPlatforms.map((platform) => (
          <button
            key={platform.name}
            onClick={() => handleSocialShare(platform)}
            className="flex flex-col items-center space-y-2 p-4 bg-muted/50 hover:bg-muted rounded-lg transition-smooth group"
          >
            <div className={`${platform.color} group-hover:scale-110 transition-transform`}>
              <Icon name={platform.icon} size={24} strokeWidth={2} />
            </div>
            <span className="text-xs font-medium text-foreground">
              {platform.name}
            </span>
          </button>
        ))}
      </div>

      {/* Copy Link */}
      <div className="border-t border-border pt-6">
        <p className="text-sm font-medium text-foreground mb-3">
          Or copy the link to share:
        </p>
        <div className="flex items-center space-x-2">
          <div className="flex-1 p-3 bg-muted rounded-lg border border-border">
            <p className="text-xs text-text-secondary font-mono truncate">
              {shareUrl}
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleCopyLink}
            iconName={copied ? "Check" : "Copy"}
            iconPosition="left"
          >
            {copied ? 'Copied!' : 'Copy'}
          </Button>
        </div>
      </div>

      {/* Referral Bonus Info */}
      <div className="mt-6 p-4 bg-accent/5 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Gift" size={18} color="var(--color-accent)" strokeWidth={2} />
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-1">
              Earn Referral Rewards
            </h3>
            <p className="text-xs text-text-secondary">
              Share your unique link and earn ₹500 for every successful referral. Your friends get a 10% discount too!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialShare;